module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-cove-abstract-hamilton-0.d927929f.jpg";